import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteFornecedor() {
  return useMutation(
    `/v1/fornecedor/id`,
    (id: string) => http.delete(`/v1/fornecedor/${id}`),
    { retry: false }
  );
}

export default useDeleteFornecedor;
